import React, {useEffect} from "react";
import {
  fetchBranchDropdown,
  getCustomField,
  hqSelectParentBranchListV2,
  resetBranchDropdown,
  selectParentBranchListV2
} from "modules/branch/redux";
import BranchDialogComponent from "./branchDialog.component";
import PropTypes from "prop-types";
import { connect, useSelector, useDispatch } from "react-redux";
import {canAccess} from "../../../../profile/redux/selector/profile.selector";
import {AccessRights} from "../../../../../lib/constants/accessRights";
import {uploadImageToS3} from "../../../../../app/feature";
import moment from "moment";
import {UploadType} from "../../../../../lib/constants/aws_s3";
import {getApiLang} from "../../../../../app/feature/constants";
import {addAlert} from "../../../../notification";

function BranchDialogContainer({
  handleClose,
  handleSubmit,
  parentBranchList,
  isEditMode = false,
  branch,
  isBranchOnly,
  ownedCompany,
  companyName,
  isHqAdmin,
  editBranchList,
  isOpen,
  companyShortName,
  canEditParent,
  canEditName,
  canEditDescription,
  canEditAddress,
  canEditContact,
  canEditEmail,
  canEditTimezone,
  canEditSocialMedia,
  canEditBranchGroup,
  canEditProductLandingLanguage,
}) {
  const lang = useSelector((state) => state.constant.languages);
  const timezones = useSelector((state) => state.constant.timezones);
  const customFields = useSelector((state) => state.branch.customField ?? []);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBranchDropdown());
    dispatch(getCustomField());
    return () => {
      dispatch(resetBranchDropdown());
    };
  }, [dispatch]);

  const handleFormSubmit = async (values, formik) => {
    if (values?.branchThemeUi?.bgImage.startsWith('data:')) {
      const result = await dispatch(uploadImageToS3({
        uploadType: UploadType.branchThemeBgImage,
        base64Image: values?.branchThemeUi?.bgImage,
        fileName: `${Math.random().toString(36).slice(2, 18)}-${moment().format("YYYYMMDDHHmmss")}.webp`
      }));

      if (result.type === uploadImageToS3.rejected) {
        dispatch(addAlert({ severity: "error", message: getApiLang(lang, result.payload.code) }));
      }
      else {
        values.branchThemeUi.bgImage = result.payload;
      }
    }

    if (values?.branchThemeUi?.bannerImage.startsWith('data:')) {
      const result = await dispatch(uploadImageToS3({
        uploadType: UploadType.branchThemeBannerImage,
        base64Image: values?.branchThemeUi?.bannerImage,
        fileName: `${Math.random().toString(36).slice(2, 18)}-${moment().format("YYYYMMDDHHmmss")}.webp`
      }));

      if (result.type === uploadImageToS3.rejected) {
        dispatch(addAlert({ severity: "error", message: getApiLang(lang, result.payload.code) }));
      } else {
        values.branchThemeUi.bannerImage = result.payload;
      }
    }

    handleSubmit(values, formik);
  }

  return (
    <BranchDialogComponent
      handleClose={handleClose}
      parentBranchList={parentBranchList}
      handleSubmit={handleFormSubmit}
      isEditMode={isEditMode}
      branch={branch}
      isBranchOnly={isBranchOnly}
      lang={lang}
      timezones={timezones}
      ownedCompany={ownedCompany}
      companyName={companyName}
      isHqAdmin={isHqAdmin}
      editBranchList={editBranchList}
      isOpen={isOpen}
      companyShortName={companyShortName}
      customFields={customFields}
      canEditParent={canEditParent}
      canEditName={canEditName}
      canEditDescription={canEditDescription}
      canEditAddress={canEditAddress}
      canEditContact={canEditContact}
      canEditEmail={canEditEmail}
      canEditTimezone={canEditTimezone}
      canEditSocialMedia={canEditSocialMedia}
      canEditBranchGroup={canEditBranchGroup}
      canEditProductLandingLanguage={canEditProductLandingLanguage}
    />
  );
}

BranchDialogContainer.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  parentBranchList: selectParentBranchListV2(state),
  isBranchOnly: state.profile.nodeName.every(
    (item) => item.remarks === "branch"
  ),
  companyShortName: state.account.shortName,
  ownedCompany: state.profile.nodeName,
  companyName: state.profile.companyName,
  isHqAdmin: state.profile.isHqAdmin,
  editBranchList: hqSelectParentBranchListV2(state),
  canEditParent: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_OWNED_BY),
  canEditName: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_NAME),
  canEditDescription: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_DESCRIPTION),
  canEditAddress: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_ADDRESS),
  canEditContact: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_CONTACT),
  canEditEmail: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_EMAIL),
  canEditTimezone: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_TIMEZONE),
  canEditSocialMedia: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_SOCIAL_MEDIA),
  canEditBranchGroup: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_GROUP),
  canEditProductLandingLanguage: canAccess(state, AccessRights.Branch.LISTING_WRITE_UPDATE_LANDING_PAGE_LANGUAGE),
});

export default connect(mapStateToProps, null)(BranchDialogContainer);
